import React, { useEffect, useRef } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";
import { Html5QrcodeScanner, Html5Qrcode } from "html5-qrcode";

const QrScannerModal = ({ onClose, onScan }) => {
  const scannerRef = useRef(null);
  const elementId = "qr-reader";

  useEffect(() => {
    const html5QrCode = new Html5Qrcode(elementId);
    
    const config = { 
      fps: 10, 
      qrbox: { width: 250, height: 250 },
      aspectRatio: 1.0
    };

    const onSuccess = (decodedText) => {
      console.log("QR Decoded:", decodedText);
      html5QrCode.stop().then(() => {
        onScan(decodedText);
      }).catch(err => {
        console.error("Error stopping scanner:", err);
        onScan(decodedText);
      });
    };

    const onError = (errorMessage) => {
      // Too noisy to log every frame failure
      // console.warn("QR Error:", errorMessage);
    };

    html5QrCode.start(
      { facingMode: "environment" },
      config,
      onSuccess,
      onError
    ).catch((err) => {
      console.error("Unable to start scanner:", err);
    });

    return () => {
      if (html5QrCode.isScanning) {
        html5QrCode.stop().catch(err => console.error("Error stopping on unmount:", err));
      }
    };
  }, [onScan]);

  const handleClose = () => {
    onClose();
  };

  return (
    <div style={styles.overlay}>
      {/* Full screen video / scanner target */}
      <div id={elementId} style={styles.video} />

      {/* Dark overlay with cutout */}
      <div style={styles.darkOverlay} />

      {/* Header */}
      <div style={styles.header}>
        <button style={styles.closeBtn} onClick={handleClose}>
          <IoCloseOutline size={26} color="#fff" />
        </button>
        <span style={styles.title}>Scan QR Code</span>
        <div style={{ width: 40 }} />
      </div>

      {/* Scan frame */}
      <div style={styles.frameContainer}>
        <div style={styles.frame}>
          <span style={{ ...styles.corner, top: 0, left: 0, borderTopWidth: 3, borderLeftWidth: 3 }} />
          <span style={{ ...styles.corner, top: 0, right: 0, borderTopWidth: 3, borderRightWidth: 3 }} />
          <span style={{ ...styles.corner, bottom: 0, left: 0, borderBottomWidth: 3, borderLeftWidth: 3 }} />
          <span style={{ ...styles.corner, bottom: 0, right: 0, borderBottomWidth: 3, borderRightWidth: 3 }} />
          {/* Scan line */}
          <div style={styles.scanLine} />
        </div>
        <div style={styles.scanIcon}>
          <BsQrCodeScan size={20} color="rgba(255,255,255,0.6)" />
          <span style={styles.hint}>Align QR code within the frame</span>
        </div>
      </div>
    </div>
  );
};

const FRAME_SIZE = 260;

const styles = {
  overlay: {
    position: "fixed", inset: 0, zIndex: 9999,
    display: "flex", flexDirection: "column",
    alignItems: "center", background: "#000",
  },
  video: {
    position: "absolute", inset: 0,
    width: "100%", height: "100%",
    objectFit: "cover",
  },
  darkOverlay: {
    position: "absolute", inset: 0,
    background: "rgba(0,0,0,0.55)",
    pointerEvents: "none",
  },
  header: {
    position: "fixed", zIndex: 3,
    top: 0, left: 0, right: 0,
    display: "flex",
    alignItems: "center", justifyContent: "space-between",
    padding: "48px 16px 16px",
  },
  closeBtn: {
    background: "rgba(255,255,255,0.2)", border: "none",
    borderRadius: "50%", width: 40, height: 40,
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer",
  },
  title: {
    color: "#fff", fontSize: 18, fontWeight: 600, letterSpacing: 0.5,
  },
  frameContainer: {
    position: "fixed",
    zIndex: 2,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex", flexDirection: "column",
    alignItems: "center", gap: 20,
  },
  frame: {
    width: FRAME_SIZE, height: FRAME_SIZE,
    position: "relative", overflow: "hidden",
  },
  corner: {
    position: "absolute", width: 28, height: 28,
    borderColor: "#00e5ff", borderStyle: "solid", borderWidth: 0,
    borderRadius: 3,
  },
  scanLine: {
    position: "absolute", left: 8, right: 8, height: 2,
    background: "linear-gradient(90deg, transparent, #00e5ff, transparent)",
    top: "50%", animation: "scanMove 2s linear infinite",
  },
  scanIcon: {
    display: "flex", alignItems: "center", gap: 8,
  },
  hint: {
    color: "rgba(255,255,255,0.7)", fontSize: 14,
  },
};

export default QrScannerModal;
